import { Mark, mergeAttributes } from '@tiptap/core';

export const LETTER_TEMPLATE_FONT_FAMILIES = Object.freeze(['helvetica', 'times', 'courier']);

export const LETTER_TEMPLATE_FONT_CSS = Object.freeze({
  helvetica: 'Helvetica, Arial, sans-serif',
  times: '"Times New Roman", Times, serif',
  courier: '"Courier New", Courier, monospace',
});

export const LetterFontExtension = Mark.create({
  name: 'letterFont',
  inclusive: true,

  addAttributes() {
    return {
      family: {
        default: 'helvetica',
        parseHTML: (element) => element.getAttribute('data-letter-font') || 'helvetica',
        renderHTML: (attributes) => ({
          'data-letter-font': attributes.family || 'helvetica',
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-letter-font]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const family = HTMLAttributes['data-letter-font'] || 'helvetica';
    const cssFamily = LETTER_TEMPLATE_FONT_CSS[family] || LETTER_TEMPLATE_FONT_CSS.helvetica;
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        style: `font-family: ${cssFamily}`,
      }),
      0,
    ];
  },

  addCommands() {
    return {
      setLetterFont:
        (family) =>
        ({ chain }) => {
          if (!LETTER_TEMPLATE_FONT_FAMILIES.includes(family)) return false;
          if (family === 'helvetica') {
            return chain().focus().unsetMark(this.name).run();
          }
          return chain().focus().setMark(this.name, { family }).run();
        },
      unsetLetterFont:
        () =>
        ({ chain }) =>
          chain().focus().unsetMark(this.name).run(),
    };
  },
});

export default LetterFontExtension;
